import Vue from "vue"
import VueRouter from "vue-router"
import store from './../store/index';



Vue.use(VueRouter)

let router = new VueRouter({
    base: '/',
    //mode: "history",
    routes: [

        {
            path: '/',
            redirect: '/auth'
        },
        //auth
        {
            path: "/auth/:slug?",
            component: () => import("@/views/auth/Login"),
        },
        {
            path: "/recover_password",
            component: () => import("@/views/auth/RecoverPassword")
        },
        {
            path: "/reset_password/:tokenPassword",
            component: () => import("@/views/auth/ResetPassword")
        },
        //loga via link com token de acesso remoto (tar)
        {
            path: "/remote_access/:tokenAccessRemote",
            component: () => import("@/views/auth/RemoteAccess")
        },

        //schedule
        {
            path: "/schedule",
            component: () => import("@/template/Default"),
            children: [
                {
                    path: "/", //doctor_schedule
                    component: () => import("@/views/schedule/Index.vue"),
                    meta: {
                        requiresAuth: true
                    }
                },
            ]
        },

        //chat
        {
            path: "/chat",
            component: () => import("@/template/Default"),
            children: [
                {
                    path: "/",
                    component: () => import("@/views/chat/Index.vue"),
                    meta: {
                        requiresAuth: true
                    }
                },
            ]
        },

        //setting
        {
            path: "/setting",
            component: () => import("@/template/Default"),
            children: [
                {
                    path: "office",
                    component: () => import("@/views/office/Index.vue"),
                    meta: {
                        requiresAuth: true
                    }
                },
                // {
                //     path: "attendants",
                //     component: () => import("@/views/attendants/Index.vue"),
                //     meta: {
                //         requiresAuth: true
                //     }
                // },
                // {
                //     path: "clinic",
                //     component: () => import("@/views/clinic/Index.vue"),
                //     meta: {
                //         requiresAuth: true
                //     }
                // },
            ]
        },

        //account
        {
            path: "/account",
            component: () => import("@/template/Account"),
            children: [
                {
                    path: "/", //doctor_schedule
                    component: () => import("@/views/account/DoctorRegister.vue"),
                },
                {
                    path: "thanks/:plan?", //doctor_schedule
                    component: () => import("@/views/account/Thanks.vue"),
                },
                {
                    path: "attendant/:invitationToken", //doctor_schedule
                    component: () => import("@/views/account/AttendantsRegister.vue"),
                }
            ]
        },
    ]
})


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.user.token) {
            next({ path: '/auth' }).catch(() => { })
        } else {
            next() // go to wherever I'm going
        }
    } else {
        next() // does not require auth, make sure to always call next()!
    }
})

export default router